import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/components/Home.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { name: 'home' }
  },
  {
    name: 'home',
    path: '/:organizationId?/:locationId/booking',
    component: Home,
    redirect: { name: 'booking' },
    children: [
      {
        name: 'booking',
        path: ':bookingId?',
        component: () => import('@/components/Booking.vue')
      },
      {
        name: 'customerInfo',
        path: ':bookingId?/customerInfo',
        component: () => import('@/components/CustomerInfo.vue')
      },
      {
        name: 'warranty',
        path: ':bookingId?/warranty',
        component: () => import('@/components/Warranty.vue')
      },
      {
        name: 'done',
        path: ':bookingId/done',
        component: () => import('@/components/Confirmation.vue')
      },
      {
        name: 'cancel',
        path: ':bookingId/cancel',
        component: () => import('@/components/Cancel.vue')
      },
      {
        name: 'cancelled',
        path: ':bookingId/cancelled',
        component: () => import('@/components/Cancel.vue'),
        props: { cancelled: true }
      }
    ]
  },
  {
    name: 'termsAndConditions',
    path: '/termsAndConditions',
    component: () => import('@/components/TermsAndConditions.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
